import deSites from '../JSON/StaticSitesAdresses/deSites.json';
import enSites from '../JSON/StaticSitesAdresses/enSites.json';
import deAtSites from '../JSON/StaticSitesAdresses/deAtSites.json';
import enAuSites from '../JSON/StaticSitesAdresses/enAuSites.json';
import enInSites from '../JSON/StaticSitesAdresses/enInSites.json';
import enSgSites from '../JSON/StaticSitesAdresses/enSgSites.json';
import enUkSites from '../JSON/StaticSitesAdresses/enUkSites.json';
import enUsSites from '../JSON/StaticSitesAdresses/enUsSites.json';
import esEsSites from '../JSON/StaticSitesAdresses/esEsSites.json';
import esSites from '../JSON/StaticSitesAdresses/esSites.json';
import esUsSites from '../JSON/StaticSitesAdresses/esUsSites.json';
import frBeSites from '../JSON/StaticSitesAdresses/frBeSites.json';
import frFrSites from '../JSON/StaticSitesAdresses/frFrSites.json';
import frSites from '../JSON/StaticSitesAdresses/frSites.json';
import itSites from '../JSON/StaticSitesAdresses/itSites.json';
import nlBeSites from '../JSON/StaticSitesAdresses/nlBeSites.json';
import nlSites from '../JSON/StaticSitesAdresses/nlSites.json';
import zhHansSites from '../JSON/StaticSitesAdresses/zhHansSites.json';
import * as language_code from '../constants/languageCode';

export const prepareAlternateData = (language: string, alias: string) => {
    switch (language) {
        case language_code.DE:
            return { language: language, url: deSites[alias] };
        case language_code.DE_AT:
            return { language: language, url: deAtSites[alias] };
        case language_code.EN:
            return { language: language, url: enSites[alias] };
        case language_code.EN_AU:
            return { language: language, url: enAuSites[alias] };
        case language_code.EN_IN:
            return { language: language, url: enInSites[alias] };
        case language_code.EN_SG:
            return { language: language, url: enSgSites[alias] };
        case language_code.EN_UK:
            return { language: language, url: enUkSites[alias] };
        case language_code.EN_US:
            return { language: language, url: enUsSites[alias] };
        case language_code.ES:
            return { language: language, url: esSites[alias] };
        case language_code.ES_ES:
            return { language: language, url: esEsSites[alias] };
        case language_code.ES_US:
            return { language: language, url: esUsSites[alias] };
        case language_code.FR:
            return { language: language, url: frSites[alias] };
        case language_code.FR_BE:
            return { language: language, url: frBeSites[alias] };
        case language_code.FR_FR:
            return { language: language, url: frFrSites[alias] };
        case language_code.IT:
            return { language: language, url: itSites[alias] };
        case language_code.NL_NL:
            return { language: language, url: nlSites[alias] };
        case language_code.NL_BE:
            return { language: language, url: nlBeSites[alias] };
        case language_code.ZH_HANS:
            return { language: language, url: zhHansSites[alias] };
        default:
            return { language: language, url: deSites[alias] };
    }
};
